var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"betButton white--text",attrs:{"x-small":"","color":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_vm._v(" Bet ")])
}
var staticRenderFns = []

export { render, staticRenderFns }